<template>
  <div class="my">
    <div class="head">
      <img v-if="userInfo.userFace" :src="$isCdn(userInfo.userFace)" alt="" />
      <img v-else src="@/assets/image/user.png" alt="" />
      <div class="info">
        <div class="name">{{ userInfo.name }}</div>
        <div class="org van-ellipsis">{{ userInfo.orgName }}</div>
      </div>
    </div>
    <div class="list-container -mt">
      <div @click="handle2nav('/project')" class="list-item border">
        <img src="@/assets/image/my/Icon.png" alt="" />
        <span class="label">上传作业</span>
        <i class="iconfont icon-arrow-down"></i>
      </div>
      <div @click="handle2nav('/history')" class="list-item border">
        <img src="@/assets/image/my/Icon_1.png" alt="" />
        <span class="label">观看历史</span>
        <i class="iconfont icon-arrow-down"></i>
      </div>
      <div @click="handle2Learn" class="list-item">
        <img src="@/assets/image/my/Icon_2.png" alt="" />
        <span class="label">我的学习</span>
        <i class="iconfont icon-arrow-down"></i>
      </div>
    </div>
    <div class="list-container mt">
      <div @click="handle2nav('/feedback')" class="list-item border">
        <img src="@/assets/image/my/Icon_3.png" alt="" />
        <span class="label">意见反馈</span>
        <i class="iconfont icon-arrow-down"></i>
      </div>
      <div @click="handle2nav('/about')" class="list-item">
        <img src="@/assets/image/my/Icon_4.png" alt="" />
        <span class="label">关于</span>
        <i class="iconfont icon-arrow-down"></i>
      </div>
    </div>
    <div class="list-container mt">
      <div @click="loginOut()" class="list-item">
        <img src="@/assets/image/my/loginOut.png" alt="" />
        <span class="label">退出登录</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    handle2Learn() {
      window.location.href = '/mobile_learn/#/course/index'
    },
    handle2nav(link) {
      this.$router.push(link)
    },
    loginOut() {
      localStorage.clear()
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.my {
  .head {
    padding: 20px 16px 16px;
    width: 100%;
    height: 130px;
    background: linear-gradient(119deg, #5861ff, #665aff 100%);
    display: flex;
    img {
      margin-right: 12px;
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
    .info {
      color: #fff;
      .name {
        font-size: 20px;
        font-weight: 700;
      }
      .org {
        margin-top: 10px;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
}

.list-container {
  margin: 0 16px;
  padding: 0 12px;
  background: #fff;
  border-radius: 6px;
  .list-item {
    padding: 12px 0;
    display: flex;
    align-items: center;
    img {
      width: 22px;
      height: 22px;
    }
    i {
      color: #c0c4cc;
    }
    .label {
      flex: 1;
      font-size: 14px;
      color: #303133;
      margin-left: 8px;
    }
    &.border {
      border-bottom: 1px solid #ebeef5;
    }
  }
}
.-mt {
  margin-top: -28px;
}
.mt {
  margin-top: 14px;
}
</style>
